import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router'
import './Layout.css'

import Footer from '../footer/Footer'
import Sidebar from '../sidebar/Sidebar'
import Loader from '../loader/view/Loader'
import { BASE_PATH_PREFIX } from '../../constants/routes'
import { useJwtExpirationWatcher } from '../../hooks/useJwtExpirationWatcher'
import { useEffect } from 'react'
import { getCommunicationTypesRequest, getDocumentModulesRequest, getDocumentTypesWithConfigurationRequest, getInvestorsForDDRequest, getPriorityTypesRequest, getRecipientGroupRequest, getRolesRequest, getStatusRequest, getUsersForDDRequest, updateCommonReducer } from '../../modules/common/services/CommonActions'
import { setNavigate } from '../../utils/history'
import { isMobileViewport } from '../../utils/viewport'

export const Layout = ({ isShowSidebar = true, isLoginPage = false, children }) => {
    const { isAuthLoading, userData } = useSelector(state => state.auth);
    const { commonLoading, selectedRole } = useSelector(state => state.common);
    const [menuCollapse, setMenuCollapse] = useState(true);
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    // Initialize navigate in the history utility
    useEffect(() => {
        setNavigate(navigate);
    }, [navigate]);

    // Auto-collapse sidebar when resizing to mobile
    useEffect(() => {
        const handleResize = () => {
            if (isMobileViewport()) {
                setMenuCollapse(true);
            }
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    // useEffect(() => {
    //     dispatch(updateCommonReducer({ commonLoading: true }));

    //     Promise.all([
            //dispatch(getRolesRequest()),
            //dispatch(getStatusRequest()),
            // dispatch(getDocumentModulesRequest()),
            //dispatch(getCommunicationTypesRequest()),
            //dispatch(getPriorityTypesRequest()),
            //dispatch(getRecipientGroupRequest()),
            //dispatch(getUsersForDDRequest()),
            //dispatch(getInvestorsForDDRequest()),
            //dispatch(getDocumentTypesWithConfigurationRequest())
    //     ]).then(() => {
    //         dispatch(updateCommonReducer({ commonLoading: false }));
    //     }).catch(() => {
    //         dispatch(updateCommonReducer({ commonLoading: false }));
    //     });
    // }, [userData?.userId]);

    useEffect(() => {
        if (selectedRole != null) {
            Promise.all([
                dispatch(getInvestorsForDDRequest()),
                dispatch(getUsersForDDRequest())
            ])
        }
    }, [selectedRole]);

    useJwtExpirationWatcher(); // Watch for JWT expiration

    const menuIconClick = () => {
        menuCollapse ? setMenuCollapse(false) : setMenuCollapse(true);
    };

    const isHomePage = location.pathname === BASE_PATH_PREFIX;
    return (
        <div>
            {isShowSidebar
                ? <Sidebar menuIconClick={menuIconClick} menuCollapse={menuCollapse} userData={userData} />
                : null
            }
            <Loader show={isAuthLoading || commonLoading}>
                {isLoginPage
                    ? children
                    : (
                        <div className={menuCollapse ? "collapse-main-warpper" : "main-wrapper"}>
                            {/* Hamburger button — visible only on mobile. Lives inside the
                                scrollable wrapper (sticky, not fixed) so it never overlaps
                                content as the page scrolls; it just stays pinned to the
                                top of this container instead of floating over it. */}
                            {isShowSidebar && !isLoginPage && (
                                <button className="mobile-sidebar-toggle" onClick={menuIconClick} aria-label="Toggle menu">
                                    &#9776;
                                </button>
                            )}
                            <div className={`p-3 ${isHomePage ? "main-content" : "main-content"}`}>
                                <div className={isHomePage ? "inner-content" : "inner-content"}
                                // style={isHomePage ? { backgroundImage: 'url("/assets/images/HomeBG.jpg")' } : {}}
                                >
                                    {children}
                                </div>
                            </div>
                        </div>
                    )
                }
            </Loader>
            <Footer menuCollapse={menuCollapse} isLoginPage={isLoginPage} />
        </div>
    )
}

export default Layout;
